export enum InstituicaoNaturezaEnum {
    Publica = 0,
    Privada = 1,
}